// @flow
import { useState } from 'react';

import clsx from 'clsx';

import { selectDomainFromFqdn } from '@gandi/cart';
import { Base, type DialogStateProps } from '@gandi/ui';

import { useExtendedSuggestion } from 'src/DomainCreate/components/ProvidedArea/modules';
import { selectHostingFromFqdn } from 'src/WebHosting/modules/selectors';
import { ErrorBoundary } from 'src/helpers/ErrorBoundary';
import { useAppSelector } from 'src/hooks/useAppSelector';

import { DomainBundle } from '../DomainBundle';

import { ProvidedRow } from './ProvidedRow';
import { XsellHosting } from './Xsell/XsellHosting';

import styles from './AvailableRow.scss';

type Props = {
  fqdn: string,
  hasBundle?: boolean,
  phasesDialogState: DialogStateProps,
};

export function AvailableRow({
  fqdn,
  hasBundle,
  phasesDialogState,
}: Props): React.MixedElement {
  const { suggestion } = useExtendedSuggestion({
    fqdn,
  });
  const domainProduct = useAppSelector(state =>
    selectDomainFromFqdn(state, fqdn),
  );
  const hostingProduct = useAppSelector(state =>
    selectHostingFromFqdn(state, fqdn),
  );
  const [isAddingToCart, setIsAddingToCart] = useState(false);

  const isPremium = suggestion?.premium || domainProduct?.isPremium;
  const showXSell =
    !isPremium &&
    ((domainProduct && !domainProduct.bundleId) ||
      isAddingToCart ||
      !!hostingProduct);

  return (
    <div className={styles.root}>
      {!hostingProduct && (
        <Base key={fqdn} backgroundColor="surface" className={styles.main}>
          <ErrorBoundary fallback={<ProvidedRow.Error fqdn={fqdn} />}>
            <ProvidedRow
              fqdn={fqdn}
              isAddingToCart={isAddingToCart}
              setIsAddingToCart={setIsAddingToCart}
              phasesDialogState={phasesDialogState}
            />
          </ErrorBoundary>
        </Base>
      )}

      {showXSell && (
        <ErrorBoundary fallback={null}>
          <XsellHosting
            className={clsx(styles.offer, styles.middle)}
            fqdn={fqdn}
            isLoading={isAddingToCart}
          />
        </ErrorBoundary>
      )}

      {hasBundle && !hostingProduct && (
        <ErrorBoundary fallback={null}>
          <DomainBundle fqdn={fqdn} className={styles.offer} />
        </ErrorBoundary>
      )}
    </div>
  );
}
